import axios from'../../axios';var fdsTransferService={/**
     * Yêu cầu chuyển tiền vào TKKQ.
     */increaseDepositAmountSubmit:function increaseDepositAmountSubmit(accountId,transferBody){return axios.post("/tranfds/accounts/".concat(accountId,"/increaseDepositAmountSubmit"),transferBody);},/**
     * Rút tiền từ tài khoản kí quỹ CCP.
     */decreaseDepositAmountSubmit:function decreaseDepositAmountSubmit(accountId,transferBody){return axios.post("/tranfds/accounts/".concat(accountId,"/decreaseDepositAmountSubmit"),transferBody);},/**
     * Thực hiện giao dịch chuyển tiền
     */execTransaction:function execTransaction(transferBody){return axios.post("/tranfds/execTransaction",transferBody);},// Nộp tiền vào tài khoản giao dịch phái sinh
increaseDTABalance:function increaseDTABalance(accountId,transferBody){return axios.post("/tranfds/accounts/".concat(accountId,"/increaseDTABalance"),transferBody);},// Rút tiền từ tài khoản giao dịch phái sinh
decreaseDTABalance:function decreaseDTABalance(accountId,transferBody){return axios.post("/tranfds/accounts/".concat(accountId,"/decreaseDTABalance"),transferBody);},/**
     * Thực hiện giao dịch chuyển tiền nội bộ
     * {
     *  "advanceAmt": 0,
     *  "description": "string"
     * }
     */processCashAdvance:function processCashAdvance(accountId,advanceBody){return axios.post("/tran/accounts/".concat(accountId,"/advanced"),advanceBody);},/**
     * Đăng ký mua chứng khoán sự kiện quyền
     * {
     *  "camastId": "string",
     *  "qtty": 0,
     *  "description": "string"
     * }
     */processRightOffRegister:function processRightOffRegister(accountId,rightOffRegisterBody){return axios.post("/tran/accounts/".concat(accountId,"/rightOffRegiter"),rightOffRegisterBody);},/**
     * Chuyển khoản chứng khoán nội bộ
     * {
     *  "receiveAccount": "string",
     *  "symbol": "string",
     *  "qtty": 0,
     *  "description": "string"
     * }
     */processTransferStock:function processTransferStock(accountId,transferBody){return axios.post("/tran/accounts/".concat(accountId,"/tranferStock"),transferBody);},/**
     * Gửi lại mã xác thực cho phần giao dịch (không có tham số???)
     */resendAuthCode:function resendAuthCode(){return axios.post("/tran/resendAuthCode");},/**
     * Kiểm tra mã xác thực
     */process2FactorAuth:function process2FactorAuth(code,transactionId,tokenId){return axios.post("/tran/twoFactorAuth",{"code":code,"transactionId":transactionId,"tokenid":tokenId});}};export default fdsTransferService;